import React, { Component } from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import { bindActionCreators } from 'redux';
import { addNotification } from 'actions/notifications/notifications';
import { connect } from 'react-redux';
import { sendGazetterTraining, deleteFromTraining } from './../../../../actions/trainings';

class Trainings extends Component {
    constructor(props) {
        super(props);
        this.sendType = this.sendType.bind(this);
    }
    async sendType(type = 'spam') {
        const {
            html, text, hash, subject, type: oldType, date, _id: mailId, toTrain, 
        } = this.props.letter;
        this.props.sendGazetterTraining({
            html,
            text,
            hash,
            subject,
            oldType,
            mailId,
            trainType: type,
            toTrain,
        });
    }

    delete = async () => {
        this.props.deleteFromTraining({ mailId: this.props.letter._id });
    }

    render() {
        return (
            <span>
                <RaisedButton 
                    className='btn'
                    labelStyle={{ fontSize: '10px' }}
                    style={{ height: '25px', margin: '10px 10px 10px 0' }}
                    buttonStyle={{ height: '25px', lineHeight: '25px', background: '#006400' }}
                    label='VESSEL'
                    onClick={() => this.sendType('vessel')}
                    primary
                />

                <RaisedButton 
                    className='btn'
                    labelStyle={{ fontSize: '10px' }}
                    style={{ height: '25px', margin: '10px 10px 10px 0', background: 'orange' }}
                    buttonStyle={{ height: '25px', lineHeight: '25px', background: 'orange' }}
                    label='CARGO'
                    onClick={() => this.sendType('cargo')}
                />

                <RaisedButton 
                    className='btn'
                    labelStyle={{ fontSize: '10px' }}
                    style={{ height: '25px', margin: '10px 10px 10px 0' }}
                    buttonStyle={{ height: '25px', lineHeight: '25px', background: '#FFFAF0' }}
                    label='SPAM'
                    onClick={() => this.sendType('spam')}
                />

                <RaisedButton 
                    className='btn'
                    labelStyle={{ fontSize: '10px' }}
                    style={{ height: '25px', margin: '10px 10px 10px 0' }}
                    buttonStyle={{ height: '25px', lineHeight: '25px', background: '#8A2BE2' }}
                    label='TC'
                    onClick={() => this.sendType('tc')}
                    secondary
                />

                <RaisedButton 
                    className='btn'
                    labelStyle={{ fontSize: '10px' }}
                    style={{ height: '25px', margin: '10px 10px 10px 0' }}
                    buttonStyle={{ height: '25px', lineHeight: '25px', background: '#4755b4' }}
                    label='Fixture'
                    onClick={() => this.sendType('fixture')}
                    secondary
                />

                <RaisedButton 
                    className='btn'
                    labelStyle={{ fontSize: '10px' }}
                    style={{ height: '25px', margin: '10px 10px 10px 0' }}
                    buttonStyle={{ height: '25px', lineHeight: '25px', background: '#b48847' }}
                    label='Recap'
                    onClick={() => this.sendType('recap')}
                    secondary
                />

                <RaisedButton 
                    className='btn'
                    labelStyle={{ fontSize: '10px' }}
                    style={{ height: '25px', margin: '10px 10px 10px 0' }}
                    buttonStyle={{ height: '25px', lineHeight: '25px', background: '#BE4141' }}
                    label='DELETE'
                    onClick={() => this.delete()}
                    secondary
                />
            </span>
        );
    }
}

export default connect(null, dispatch => bindActionCreators({ addNotification, sendGazetterTraining, deleteFromTraining }, dispatch))(Trainings);



// WEBPACK FOOTER //
// ./app/components/Letters/Single/Gazetter/Trainings.jsx